import { inject, Injectable } from "@angular/core";

import {
  VaultExplorerService,
  VaultItemGroup,
} from "@bitwarden/web-vault/app/services/dali/vault-explorer.service";
import { VaultCodeEnum } from "@bitwarden/web-vault/app/services/dali/type/dali.type";

import {
  DedupStyleValue,
  TRANSACTION_VAULT_DEDUP_STYLES,
} from "./vault-transaction-dedup.constants";

/**
 * Shared duplicate grouping for vault source explorer UI and silent login cleanup.
 */
@Injectable({
  providedIn: "root",
})
export class DuplicatesService {
  private vaultExplorer = inject(VaultExplorerService);

  getGroupedItems(type: VaultCodeEnum, includeIdForDedup: boolean): VaultItemGroup[] {
    return this.vaultExplorer.getGroupedItems(type, includeIdForDedup);
  }

  /** Uses explorer-loaded items (`_vaultData` for this type). */
  getGroupedItemsCustom(type: VaultCodeEnum, excludeKeys: string[]): VaultItemGroup[] {
    return this.vaultExplorer.getGroupedItemsCustom(type, excludeKeys);
  }

  /**
   * Uses decrypted vault reader cache — works before the explorer selects this type
   * (e.g. immediately after login).
   */
  getGroupedItemsCustomFromVault(type: VaultCodeEnum, excludeKeys: string[]): VaultItemGroup[] {
    return this.vaultExplorer.getGroupedItemsCustomFromVaultReader(type, excludeKeys);
  }

  getTransactionDuplicateGroupsFromVault(style: DedupStyleValue): VaultItemGroup[] {
    if (style === "ID") {
      return this.vaultExplorer.groupItemsByTransactionId(
        this.vaultExplorer.getCachedItemsByType(VaultCodeEnum.Transaction),
      );
    }
    const cfg = TRANSACTION_VAULT_DEDUP_STYLES.find((s) => s.value === style)!;
    return this.getGroupedItemsCustomFromVault(VaultCodeEnum.Transaction, cfg.excludeKeys);
  }
}
